export const CDN_HOST = 'https://cdn.alfaqr.com';
export const CDN_ASSETS_VERSION = '1';

/**
 * Book JSON sometimes stores a path like `/books/foo.pdf`. In production that would otherwise
 * resolve against the site origin (e.g. Vercel) instead of the CDN.
 */
export function resolveBookPdfUrl(url: string): string {
  const t = url.trim();
  if (!t) return t;
  if (/^https?:\/\//i.test(t)) return t;
  if (t.startsWith('//')) return `https:${t}`;
  if (t.startsWith('/')) return `${CDN_HOST}${t}`;
  return `${CDN_HOST}/${t}`;
}

/**
 * Generate versioned URL of static asset
 *
 * @param {string} path the path of static asset
 * @returns {string}
 */

export const makeCDNUrl = (path: string) => {
  return `${CDN_HOST}/${path}`;
};
export const makeCDNImagesUrl = (path: string = '') => {
  return `${CDN_HOST}/images/${path}`;
};